
module.exports = (function ($, window, document, undefined) {
    "use strict";
    var self;

    // Create the defaults once
    var pluginName = "gpmQuoteBox",
        defaults = {
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        self = this;
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            //Variables
            self.$el = $(this.element);
            self.Form = $('.formbuilder');
            self.Culture = $('body').data('culture');
            self.ClientId = $('body').data('client-id');
            self.ProjectId = $('body').data('project-id');
            self.QuoteBox = $('#QuoteBox');
            self.RemitterBankCountry = $('#RemitterBankCountry');

            self.PaymentCurrency = $('#PaymentCurrency');
            self.PaymentAmount = $('#PaymentAmount');
            self.SettlementCurrency = $('#SettlementCurrency');
            self.ClientRate = $('#ClientRate');

            self.SettlementCurrency2 = $('#SettlementCurrency2');
            self.SettlementAmount = $('#SettlementAmount');
            self.PaymentCurrency2 = $('#PaymentCurrency2');
            self.ClientRate2 = $('#ClientRate2');

            self.ErrorLog = $('#ErrorLog');
            self.RefreshQuote = $('#RefreshQuote');

            self.FeeAmount = $('#FeeAmount');
            self.Total = $('#Total');

            self.FirstName = $('#FirstName');
            self.LastName = $('#LastName');

            self.RemitterCountry = $('#RemitterCountry');

            //Bindings
            $("input[name=AmountType]:radio").change($.proxy(self.amountTypeChanged, self));
            self.RemitterBankCountry.change($.proxy(self.getCurrencies, self));
            self.RefreshQuote.click($.proxy(self.getQuote, self));
            self.PaymentCurrency.change($.proxy(self.currenciesChanged, self));
            self.PaymentCurrency2.change($.proxy(self.currenciesChanged, self));
            self.SettlementCurrency.change($.proxy(self.currenciesChanged, self));
            self.SettlementCurrency2.change($.proxy(self.currenciesChanged, self));
            //Defaults
            //$(self.RemitterCountry).attr('disabled', true);
            //$(self.RemitterCountry).val($(self.RemitterBankCountry).val()).trigger('change');
            self.amountTypeChanged();
            self.RemitterBankCountry.trigger('change');
        },
        linkedCurrencies: function (main, dependent) {
            dependent.val(main.val()).trigger('change');
        },
        amountTypeChanged: function () {
            var amountType = $('input[name=AmountType]:checked').val();
            self.Form.validate().resetForm();
            self.PaymentAmount.attr('disabled', amountType != "PAYMENT");
            self.PaymentAmount.prop('required', amountType == "PAYMENT");
            self.PaymentCurrency.attr('disabled', amountType != "PAYMENT");
            self.SettlementCurrency.attr('disabled', amountType != "PAYMENT");

            self.SettlementCurrency2.attr('disabled', amountType == "PAYMENT");
            self.SettlementAmount.attr('disabled', amountType == "PAYMENT");
            self.SettlementAmount.prop('required', amountType != "PAYMENT");
            self.PaymentCurrency2.attr('disabled', amountType == "PAYMENT");
            self.currenciesChanged();
        },
        currenciesChanged: function () {
            var amountType = $('input[name=AmountType]:checked').val();
            var isPayment = amountType == 'PAYMENT';

            $('#PaymentCurrencyPrecision').val(isPayment ? $('#PaymentCurrency option:selected').data('precision') : $('#PaymentCurrency2 option:selected').data('precision'));
            $('#SettlementCurrencyPrecision').val(isPayment ? $('#SettlementCurrency option:selected').data('precision') : $('#SettlementCurrency2 option:selected').data('precision'));
        },
        getCurrencies: function () {
            if (self.RemitterBankCountry.val()) {
                self.QuoteBox.removeClass('hidden');
                $(self.RemitterCountry).val($(self.RemitterBankCountry).val()).trigger('change');
                $.ajax({
                    url: '/api/data/paymentCurrencies/' + self.ClientId + '/' + self.RemitterBankCountry.val(),
                    data: "c=" + self.Culture,
                    dataType: 'json',
                    type: 'get',
                    success: function (json) {
                        self.PaymentCurrency.find('option').remove()
                        self.PaymentCurrency2.find('option').remove()

                        $.each(json.paymentCurrency, function (index, value) {
                            self.PaymentCurrency.append($('<option>').text(value.code).attr('data-precision', value.precision).prop("selected", value.isDefault));
                            self.PaymentCurrency2.append($('<option>').text(value.code).attr('data-precision', value.precision).prop("selected", value.isDefault));
                        });

                        self.PaymentCurrency.trigger('change');
                        self.PaymentCurrency2.trigger('change');
                    }
                });

                $.ajax({
                    url: '/api/data/settlementCurrencies/' + self.ClientId,
                    data: "c=" + self.Culture,
                    dataType: 'json',
                    type: 'get',
                    success: function (json) {
                        self.SettlementCurrency.find('option').remove()
                        self.SettlementCurrency2.find('option').remove()

                        $.each(json.settlementCurrency, function (index, value) {
                            self.SettlementCurrency.append($('<option>').text(value.code).attr('data-precision', value.precision).prop("selected", value.isDefault));
                            self.SettlementCurrency2.append($('<option>').text(value.code).attr('data-precision', value.precision).prop("selected", value.isDefault));
                        });

                        self.SettlementCurrency.trigger('change');
                        self.SettlementCurrency2.trigger('change');
                    }
                });

                if (self.culture == 'en-US') {
                    self.RemitterCountry.select2().val(self.RemitterBankCountry);
                    self.RemitterCountry.trigger('change');
                }
            }
        },
        getQuote: function () {
            var amountType = $('input[name=AmountType]:checked').val();
            var isPayment = amountType == 'PAYMENT';

            if (!(isPayment ? self.PaymentAmount.valid() : self.SettlementAmount.valid())) {
                return;
            }

            var amount = (isPayment ? self.PaymentAmount.val() : self.SettlementAmount.val());
            if ((/./i.test(amount))) {
                //amount = amount + '.00';
            }

            if (isPayment)
            {
                self.linkedCurrencies(self.PaymentCurrency, self.PaymentCurrency2);
                self.linkedCurrencies(self.SettlementCurrency, self.SettlementCurrency2);
            }
            else {
                self.linkedCurrencies(self.PaymentCurrency2, self.PaymentCurrency);
                self.linkedCurrencies(self.SettlementCurrency2, self.SettlementCurrency);
            }

            $.ajax({
                url: '/api/gp/quote/' + self.ClientId,
                dataType: 'json',
                data: 'remitterBankCountry=' + self.RemitterBankCountry.val()
                    + '&settlementCurrencyCode=' + (isPayment ? self.SettlementCurrency.val() : self.SettlementCurrency2.val())
                    + '&settlementCurrencyPrecision=' + $('#SettlementCurrencyPrecision').val()
                    + '&paymentCurrencyCode=' + (isPayment ? self.PaymentCurrency.val() : self.PaymentCurrency2.val())
                    + '&paymentCurrencyPrecision=' + $('#PaymentCurrencyPrecision').val()
                    + '&amount=' + amount
                    + '&amountType=' + amountType
                    + '&firstName=' + self.FirstName.val()
                    + '&lastName=' + self.LastName.val()
                    + '&c=' + self.Culture,
                type: 'get',
                success: function (json) {
                    //console.log(json);
                    //console.log(json.creationDate);
                    //console.log(json.status.success);

                    if (json.status.success == true) {
                        self.ClientRate.text('@ ' + json.item.clientRate + ' = ' + json.item.settlementAmount);
                        self.SettlementAmount.val(json.item.settlementAmount)
                        self.ClientRate.css('display', 'block');
                        self.ClientRate2.text('@ ' + json.item.clientRate + ' = ' + json.item.paymentAmount);
                        self.PaymentAmount.val(json.item.paymentAmount)
                        self.ClientRate2.css('display', 'block');

                        self.FeeAmount.text(json.feeAmount);
                        self.Total.text(json.itemsTotal);
                    }
                    else {
                        self.ErrorLog.text(json.status.error[0].value);
                    }
                }
            });
        },
        loadData: function (apiUrl, name, option, group) {
            $(option).remove();
            $(group).hide();
            if ($(name).val()) {
                var defaultValue = $(name).attr('data-default-value');
                $.ajax({
                    url: apiUrl,
                    data: "c=" + self.Culture,
                    dataType: 'json',
                    type: "get",
                    success: function (json) {
                        $.each(json, function (key, value) {
                            $(name).append($('<option>').text(value).attr('value', key));
                        });
                        if ($(option).size() > 0) {
                            $(group).show();
                            $(name).val(defaultValue).trigger('change');
                        }
                    }
                }).done(function (data) {
                    //console.log('ok: write cookies ' + self.$test2.val() + ' :' + data);
                }).error(function () {
                    //console.log('error: write cookies ' + self.$test2.val());
                });
            }
        },
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
